import api from './api';

// Échanges clients d'un dossier atelier.
// ⚠️ Préfixe /planning-echanges et non /planning : le verrou « pas de
// technicien » du routeur couperait le Planning entier s'il était monté sur
// /api/planning (constaté en recette).
export const planningEchanges = {
  // La conversation du dossier — regroupée par n° d'OR quand il existe.
  list: (interventionId) => api.get(`/planning-echanges/dossier/${interventionId}`),

  create: (interventionId, data) => api.post(`/planning-echanges/dossier/${interventionId}`, data),

  update: (echangeId, data) => api.put(`/planning-echanges/detail/${echangeId}`, data),

  // Tableau des derniers contacts (dossiers non restitués).
  derniersContacts: (jours = 90) =>
    api.get(`/planning-echanges/derniers-contacts?jours=${jours}`),
};

export default planningEchanges;
